import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-delivery-popover',
  templateUrl: './help-delivery-popover.component.html',
  styleUrls: ['./help-delivery-popover.component.scss'],
})
export class HelpDeliveryComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
